module.exports = __webpack_public_path__ + "static/media/cover-up01.0f566454.jpg";